import React from 'react';
import { Redirect } from 'react-router-dom';

const withRedirect = (handler) => (WrappedComponent) =>
  function withRedirectComponent(props) {
    const [condition, path] = handler(props);

    return condition ? <Redirect to={path} /> : <WrappedComponent {...props} />;
  };

export default withRedirect;
